import Link from "gatsby-link";
import styled, { css } from "styled-components";
import { colors, fonts, media, getOuterSpace } from "../../style/constants";

export const Wrapper = styled.nav`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(1, 1fr);

  grid-gap: 1rem;
  padding: 1rem;
  ${media.md`
  padding: 3rem;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(1, 1fr);
  `}
  ${media.sm`
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(1, 1fr);
    padding: 1.5rem;
    display: block;
  `}


  li {
    a {
      transition: color 0.4s ease;
      will-change: color;
      position: relative;

      &:hover {
        color: #fff;

        &::before {
          transform: translate(0, -50%);
          opacity: 1;
        }
      }
    }
  }

  ${media.md`

  `}
`;

export const Nav = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  grid-column: 2 / span 4;

  ${media.md`

  `}
`;

export const NavItem = styled.li`
  list-style: none;
  padding: 0.5rem 0;
  line-height: 1em;

  &.col-start-2 {
    grid-column-start: 2;
    ${media.md`
    grid-column-start: 1;
  `}
  }

  &:last-child {
    padding-bottom: 0;
  }

  a {
    font-size: 0.9rem;
    font-family: ${fonts.mono};
    pointer-events: all;
    transition: color 0.1s ease;
    line-height: 1em;
    ${(props) =>
      props.highlight
        ? css`
            color: ${colors.red500};

            &:hover::before {
              display: none !important;
            }
          `
        : css`
            color: ${colors.gray500};
          `}
  }
`;

export const NavLink = styled(Link).attrs({
  activeClassName: "active",
})`
  &.active {
    color: #fff;

    &::before {
      transform: translate(0, -50%);
      opacity: 1;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Menu/style.js